var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var NotWrappedError = /** @class */ (function (_super) {
    __extends(NotWrappedError, _super);
    function NotWrappedError() {
        return _super.call(this, 'You are trying to access auth outside of AuthProvdier. wrap your application with AuthProvider') || this;
    }
    return NotWrappedError;
}(Error));
export default NotWrappedError;
//# sourceMappingURL=NotWrappedError.js.map